import type { AdminListProjectPostsParams } from '../api'
import postService from './admin-post.service'
import { EAdminPostQueryKey } from './admin-post.types'

export const adminListProjectPostsOptions = (
  params: AdminListProjectPostsParams,
) => {
  return {
    queryKey: [EAdminPostQueryKey.ADMIN_LIST_PROJECT_POSTS, params],
    queryFn: () => postService.adminListProjectPosts(params),
  }
}
